import { render, staticRenderFns } from "./CertificateReady.vue?vue&type=template&id=942c656e"
import script from "./CertificateReady.vue?vue&type=script&lang=js"
export * from "./CertificateReady.vue?vue&type=script&lang=js"
import style0 from "./CertificateReady.vue?vue&type=style&index=0&id=942c656e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports